export default "https://cdn-static.gokick.com/assets/cf07e8c5970f78b6a967654f4a6b4453caa2db11/images/logo.fe82f4ad349e614dc769d17dbf45d7bb.svg";